import BaseApiRepository from './baseApiRepository'
import ReportModel from '../models/reportModel'
import CommentModel from '../models/commentModel'
import SearchAreaStatusEnum from '../enums/searchAreaStatusEnum'
import { RepositoryFactory, Repositories } from '../repositories/repositoryFactory'

export default class requestRepository extends BaseApiRepository {

  async createRequest (report: ReportModel): Promise<any> {
    const requestVariables = []

    requestVariables.push({ name: 'vehicle_type', value: report.vehicleType.id })

    const searchAreaGroups: any[] = []

    // report.vehicleType.searchAreas.forEach((area) =>
    for (let index = 0; index < report.vehicleType.searchAreas.length; index++) {
      const area = report.vehicleType.searchAreas[index]
      const areaVariables = []
      areaVariables.push({ name: 'threat', value: area.status !== SearchAreaStatusEnum.Accepted })
      areaVariables.push({ name: 'search_area', value: area.id })

      const areaCommentValues: any[] = []
      // const addCommentsLoop = area.comments.map(async (comment: CommentModel) => {
      for (let index2 = 0; index2 < area.comments.length; index2++) {
        const comment = area.comments[index2]
        let photo = false
        let text = comment.text

        // add photo
        if (comment.img !== '') {
          const photoCall = await RepositoryFactory.get(Repositories.Photo).postPhoto(comment.img).then((response: any) => {
            photo = response.id
          })
        }
        let commentValue = []

        if (text) {
          commentValue.push({
            name: 'comment',
            value: text
          })
        }

        if (photo) {
          commentValue.push({
            name: 'image',
            value: photo
          })
        }

        areaCommentValues.push(commentValue)
      }

      areaVariables.push({ name: 'comment_group', value: areaCommentValues })

      searchAreaGroups.push(areaVariables)
    }




    requestVariables.push({ name: 'search_area_group', value: searchAreaGroups })

    let requestStatus = 'approved'
    switch (report.vehicleType.status) {
    case 'approved_by_csi':
      requestVariables.push({ name: 'csi_approved', value: true })
      requestStatus = 'approved'
      break
    case 'rejected':
      requestStatus = 'rejected'
    }

    requestVariables.push({ name: 'status', value: requestStatus })

    const requestParameters = {
      'processDefinitionKey': 'bac-vehicle-security-check',
      'variables': requestVariables
    }

    return this.post('request', requestParameters)
  }

}
